// /* eslint-disable no-unused-vars */
// import { useState, useEffect } from 'react';
// import ConnectionLostModal from '../utils/ConnectionLost';

// const enigma = require('enigma.js');
// const schema = require('enigma.js/schemas/12.170.2.json');
// const SenseUtilities = require('enigma.js/sense-utilities');

// const useQlikApp = (handleLoggedInChange) => {
//   const [qlikApp, setQlikApp] = useState(null);

//   useEffect(() => {
//     (async () => {
//       const config = {
//         host: 'qdt.qlik.com',
//         appId: '288cdb78-f6f5-4912-8940-a5eeb6315bf4',
//       };

//       const url = SenseUtilities.buildUrl(config);
//       const session = enigma.create({
//         schema,
//         url,
//       });

//       session.on('closed', () => {
//         console.error('Qlik Sense Session closed.');
//         // handleLoggedInChange(false);
//         const refreshUrl = window.location;
//         const timeoutMessage = 'Due to inactivity, the app has been paused. Please refresh to continue.';
//         ConnectionLostModal({ refreshUrl, timeoutMessage });
//       });

//       session.on('suspended', () => {
//         console.log('Session was suspended, retrying...');
//         session.resume()
//           .then(() => console.log('Session was properly resumed'));
//       });

//       const global = await session.open();
//       const app = await global.openDoc(config.appId);

//       setQlikApp(app);
//     })();
//   }, []);
//   return qlikApp;
// };

// export default useQlikApp;

import { useState, useEffect } from 'react';
import qlikAppPromise from 'config/qlikApp';

const useQlikApp = () => {
  const [qlikApp, setQlikApp] = useState(null);
  useEffect(() => {
    (async () => {
      const _qlikApp = await qlikAppPromise;
      setQlikApp(_qlikApp);
    })();
  }, []);
  return qlikApp;
};

export default useQlikApp;
